import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { api } from '../api.js';

export default function DepartmentsAdmin() {
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);
  const [name, setName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  const reload = () => {
    api.get('/api/departments?includeInactive=true').then((res) => setDepartments(res.data.departments)).catch((err) => toast.error(err.message));
  };
  useEffect(() => { reload(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post('/api/departments', { name: name.trim() });
      toast.success(t('departments.created'));
      setName(''); reload();
    } catch (err) { toast.error(err.message); }
  };

  const saveEdit = async (id) => {
    try {
      await api.put(`/api/departments/${id}`, { name: editName.trim() });
      toast.success(t('departments.updated'));
      setEditingId(null); reload();
    } catch (err) { toast.error(err.message); }
  };

  const toggleActive = async (d) => {
    try {
      await api.put(`/api/departments/${d.id}`, { active: !d.active });
      reload();
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-lg font-semibold mb-4">{t('departments.title')}</h1>
      <form onSubmit={create} className="card p-4 mb-4 flex items-end gap-3">
        <div className="flex-1">
          <label className="label">{t('departments.name')}</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="IT, Service, Pièces…" />
        </div>
        <button type="submit" className="btn-primary">{t('departments.new')}</button>
      </form>
      <ul className="space-y-2">
        {departments.map((d) => (
          <li key={d.id} className="card p-3 flex items-center justify-between">
            {editingId === d.id ? (
              <input
                className="input flex-1 mr-2"
                value={editName}
                autoFocus
                onChange={(e) => setEditName(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && saveEdit(d.id)}
              />
            ) : (
              <span className={`font-medium ${!d.active ? 'text-zinc-600 line-through' : ''}`}>{d.name}</span>
            )}
            <div className="flex gap-1 text-xs">
              {editingId === d.id ? (
                <>
                  <button onClick={() => saveEdit(d.id)} className="btn-primary text-xs">{t('common.save')}</button>
                  <button onClick={() => setEditingId(null)} className="btn-ghost text-xs">{t('common.cancel')}</button>
                </>
              ) : (
                <>
                  <button onClick={() => { setEditingId(d.id); setEditName(d.name); }} className="btn-ghost text-xs">{t('common.edit')}</button>
                  <button onClick={() => toggleActive(d)} className="btn-ghost text-xs">
                    {d.active ? t('common.deactivate', 'Désactiver') : t('common.activate', 'Activer')}
                  </button>
                </>
              )}
            </div>
          </li>
        ))}
        {departments.length === 0 && <li className="text-sm text-zinc-500 py-6 text-center">{t('departments.empty')}</li>}
      </ul>
    </div>
  );
}
